/*
  Cambio de color sin recargar la pagina.

  EL PROBLEMA. En Alma Velari cada color es un producto independiente, con su
  propia URL, porque lo exige la convencion de SKU. El selector de color eran
  enlaces a esos productos, asi que pulsar un color era una navegacion real del
  navegador: pantallazo en blanco, la pagina aparecia arriba y luego bajaba. El
  intento anterior guardaba el scroll en sessionStorage y lo restauraba al
  llegar, lo que disimulaba el salto pero no podia evitar el flash: mientras sea
  una navegacion de verdad, el navegador tira la pagina y pinta otra.

  LA SOLUCION. La Section Rendering API de Shopify sirve una seccion concreta ya
  renderizada para cualquier producto: /products/handle?sections=id1,id2. Se
  piden las dos secciones que de verdad cambian entre colores y se sustituyen en
  el sitio. No hay navegacion, asi que no hay flash ni salto, y en vez de los
  427 KB de HTML de la ficha completa viajan unos 57 KB.

  Las secciones que cambian son main y av_combinalo. Se comprobo una por una
  comparando dos colores de la misma familia: av_ugc_prod, av_tramos, av_resenas
  y disclosures salen identicas, asi que no se tocan.

  LOS IDS NO SE ESCRIBEN A MANO. El id real es del tipo
  "template--33375099388295__main" y ese numero es del tema: si algun dia se
  publica un duplicado, cambia. Se leen del DOM.

  LOS SCRIPTS EN LINEA NO SOBREVIVEN. El HTML que entra por el DOM no ejecuta
  los <script> que lleve dentro. De los cuatro de la ficha, tres aguantan porque
  delegan en document o son custom elements; el de los puntos de la galeria no,
  y por eso se paso a assets/av-galeria-puntos.js.

  SIN JAVASCRIPT SIGUE FUNCIONANDO. Los circulos son <a href> de verdad, asi que
  los buscadores los siguen y, si esto falla, el navegador navega como antes.
*/
(function () {
  if (window.avColor) return;
  window.avColor = true;

  var SEL = '.av-colores__lista a.av-color';
  var ESPERA = 2500; // si tarda mas, se navega de verdad antes que dejarla colgada

  var cache = Object.create(null);
  var enCurso = Object.create(null);

  function ruta(href) {
    var a = document.createElement('a');
    a.href = href;
    return a.pathname;
  }

  function seccionMain() {
    var info = document.querySelector('product-info');
    return info && info.closest('[id^="shopify-section-"]');
  }

  function ids() {
    var out = [];
    var main = seccionMain();
    if (main) out.push(main.id.slice('shopify-section-'.length));
    var comb = document.querySelector('[id^="shopify-section-"][id$="__av_combinalo"]');
    if (comb) out.push(comb.id.slice('shopify-section-'.length));
    return out;
  }

  // La primera foto del color nuevo se precarga en cuanto llega el HTML. Sin
  // esto el marcado entra instantaneo pero la galeria se queda un momento en
  // blanco, que es justo el parpadeo que se quiere quitar.
  function precargar(datos) {
    try {
      for (var id in datos) {
        var doc = new DOMParser().parseFromString(datos[id], 'text/html');
        var img = doc.querySelector('.product__media-list img');
        if (!img) continue;
        var pre = new Image();
        if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
        if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
        if (img.getAttribute('src')) pre.src = img.getAttribute('src');
        return;
      }
    } catch (e) {}
  }

  function traer(destino) {
    if (cache[destino]) return Promise.resolve(cache[destino]);
    if (enCurso[destino]) return enCurso[destino];

    var lista = ids();
    if (!lista.length) return Promise.reject(new Error('sin secciones'));

    var p = fetch(destino + '?sections=' + lista.join(','), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        delete enCurso[destino];
        cache[destino] = d;
        precargar(d);
        return d;
      })
      .catch(function (e) {
        delete enCurso[destino];
        throw e;
      });

    enCurso[destino] = p;
    return p;
  }

  function aplicar(destino, datos) {
    // Donde esta la ficha en pantalla ahora mismo. Si el color nuevo tiene otro
    // numero de fotos o de tallas, la seccion cambia de alto y lo que la
    // clienta esta mirando se desplazaria. Se vuelve a dejar en su sitio.
    var antes = seccionMain();
    var ancla = antes ? antes.getBoundingClientRect().top : null;

    Object.keys(datos).forEach(function (id) {
      var viejo = document.getElementById('shopify-section-' + id);
      if (!viejo) return;
      var nuevo = new DOMParser().parseFromString(datos[id], 'text/html').body.firstElementChild;
      if (nuevo) viejo.replaceWith(nuevo);
    });

    if (ancla !== null) {
      var ahora = seccionMain();
      if (ahora) {
        var desvio = ahora.getBoundingClientRect().top - ancla;
        if (Math.abs(desvio) > 1) window.scrollBy(0, desvio);
      }
    }

    // Cambiar de color no debe apilar historial: la clienta llega de una
    // coleccion y espera que "atras" la devuelva alli, no al color anterior.
    try { history.replaceState({ avColor: true }, '', destino); } catch (e) {}

    var can = document.querySelector('link[rel="canonical"]');
    if (can) can.href = location.origin + destino;

    medir(destino);
  }

  /*
    Analitica.

    Sin recarga, Shopify no emite su propia vista de pagina, asi que los
    informes dejaban de contar los colores secundarios. Antes del cambio si los
    contaban, porque cada color era una carga real: era una capacidad que se
    perdia. Se recupera emitiendo la vista a mano.

    ShopifyAnalytics.lib.page() produce los mismos dos esquemas que una carga
    normal (storefront_customer_tracking 4.30 y 5.9). IGNORA el path que se le
    pase: lee location.href y el <link rel=canonical> del DOM, asi que hay que
    llamarlo DESPUES de haber actualizado los dos. El page_id lo renueva el, de
    modo que no hay riesgo de que la vista se deduplique.

    Hay que mover ademas ShopifyAnalytics.meta: lleva el id del producto en
    .product.id y en .page.resourceId, y si no se actualizan Shopify atribuye la
    vista al color por el que se entro.

    AVISO: ShopifyAnalytics.lib es API interna de Shopify, no documentada. Si
    Shopify la cambia, esto deja de medir, pero no rompe nada: va en try/catch y
    la tienda sigue igual. Si algun dia los informes dejan de ver los colores,
    mirar aqui primero.

    A Meta NO se le manda nada a proposito (decidido el 26/10/2026). Si existe
    fbq en la pagina —lo carga el gestor de pixeles web—, pero el ViewContent
    manual se quito: el dato que se usa es a que color LLEGA la clienta desde el
    anuncio, que es una carga real y se registra entera, y mandar content_ids con
    el id de producto de Shopify mete ids que el catalogo de Meta puede no
    reconocer. Medido ademas: ese pixel no emite por el navegador, va por CAPI.
  */
  function medir(destino) {
    try {
      var info = document.querySelector('product-info');
      var h1 = document.querySelector('.product__title h1') || document.querySelector('h1');
      var datos = {
        url: destino,
        producto_id: (info && info.dataset.productId) || null,
        titulo: h1 ? h1.textContent.trim() : null
      };
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('av_color_visto', datos);
      }

      // La vista de pagina, para que los informes de Shopify sigan contando
      // cada color. El orden importa: esto va despues de replaceState y del
      // canonical, que es de donde lib.page saca la URL.
      var sa = window.ShopifyAnalytics;
      if (sa && sa.meta && datos.producto_id) {
        var pid = Number(datos.producto_id);
        if (sa.meta.product) {
          sa.meta.product.id = pid;
          sa.meta.product.gid = 'gid://shopify/Product/' + pid;
          sa.meta.product.handle = destino.split('/').pop();
        }
        if (sa.meta.page) sa.meta.page.resourceId = pid;
      }
      if (sa && sa.lib && typeof sa.lib.page === 'function') {
        sa.lib.page(null, { page_type: 'product' });
      }
    } catch (e) {}
  }

  // Adelantarse: al pasar el raton o al apoyar el dedo ya se pide el HTML, asi
  // que cuando llega la pulsacion suele estar en memoria y el cambio es
  // inmediato. En movil no hay raton, y touchstart da el margen que haya.
  function adelantar(e) {
    var a = e.target.closest && e.target.closest(SEL);
    if (!a) return;
    var destino = ruta(a.getAttribute('href'));
    if (destino !== location.pathname) traer(destino).catch(function () {});
  }

  document.addEventListener('mouseover', adelantar);
  document.addEventListener('touchstart', adelantar, { passive: true });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest(SEL);
    if (!a) return;

    // Pestaña nueva, rueda o modificadores: que el navegador haga lo suyo.
    if (e.defaultPrevented || e.button !== 0 ||
        e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var destino = ruta(a.getAttribute('href'));
    e.preventDefault();
    if (destino === location.pathname) return;

    a.classList.add('av-color--cargando');
    var rendido = false;
    var reloj = setTimeout(function () {
      rendido = true;
      window.location.assign(destino);
    }, ESPERA);

    traer(destino).then(
      function (d) {
        if (rendido) return;
        clearTimeout(reloj);
        aplicar(destino, d);
      },
      function () {
        if (rendido) return;
        clearTimeout(reloj);
        // Que la clienta llegue al color, aunque sea con recarga.
        window.location.assign(destino);
      }
    );
  });
})();
